import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadAllStudents } from "../../lib/api/student";
import { StudentHomeForm } from "../../components/student/StudentHomeForm";

const Home = () => {
  const navigate = useNavigate();

  const [students, setStudents] = useState();

  const requestLoadAllStudents = useCallback(async () => {
    const { data } = await loadAllStudents();
    setStudents(data);
    //console.log(data);
  }, []);

  useEffect(() => {
    requestLoadAllStudents();
  }, [requestLoadAllStudents]);

  const handleDetail = (e) => {
    const id = e.target.value;
    navigate(`/students/${id}`);
  };

  return (
    <div>
      <Container fluid="md">
        <StudentHomeForm students={students} handleDetail={handleDetail} />
      </Container>
    </div>
  );
};

export default Home;
